/** Ready-made routines offered by the web and mobile editors. */
export const routineTemplates = [
    {
        label: 'Veče za igru',
        hint: 'Discord, FiveM i muzika jednom rečenicom',
        draft: {
            name: 'Veče za igru',
            enabled: true,
            stopOnError: false,
            triggers: [{ type: 'voice', phrase: 'spremi igru' }],
            conditions: [{ type: 'pc_connected' }],
            steps: [
                { type: 'action', action: 'app.open', params: { app: 'discord' } },
                { type: 'wait', seconds: 5 },
                { type: 'action', action: 'fivem.connect', params: {} },
                { type: 'action', action: 'youtube.play', params: { query: 'muzika za igru mix' } },
                { type: 'say', text: 'Sve je spremno. Srećno na serveru.' },
            ],
        },
    },
    {
        label: 'Igranje na PS5',
        hint: 'Upali PS5 i TV na njegov HDMI jednom rečenicom',
        draft: {
            name: 'Igranje na PS5',
            enabled: true,
            stopOnError: false,
            triggers: [{ type: 'voice', phrase: 'idemo plejka' }],
            conditions: [{ type: 'pc_connected' }],
            steps: [
                { type: 'action', action: 'ps5.power', params: { state: 'on' } },
                { type: 'say', text: 'PS5 se pali. Uživaj!' },
            ],
        },
    },
    {
        label: 'Film veče',
        hint: 'Upali TV i otvori Netflix',
        draft: {
            name: 'Film veče',
            enabled: true,
            stopOnError: false,
            triggers: [{ type: 'voice', phrase: 'film veče' }],
            conditions: [{ type: 'pc_connected' }],
            steps: [
                { type: 'action', action: 'tv.app', params: { app: 'Netflix' } },
                { type: 'say', text: 'Netflix je na TV-u. Uzmi kokice.' },
            ],
        },
    },
    {
        label: 'Pad servera',
        hint: 'Javi mi čim MILPET prestane da odgovara',
        draft: {
            name: 'Pad servera',
            enabled: true,
            stopOnError: false,
            triggers: [{ type: 'server_down' }],
            conditions: [],
            steps: [
                { type: 'say', text: 'Pažnja, {server} ne odgovara.' },
                {
                    type: 'action',
                    action: 'phone.notify',
                    params: { title: '{server} je pao', text: 'Server ne odgovara od {vreme}.' },
                },
            ],
        },
    },
    {
        label: 'Server ponovo radi',
        hint: 'Javi na telefon i u Discord kad se podigne',
        draft: {
            name: 'Server ponovo radi',
            enabled: true,
            stopOnError: false,
            triggers: [{ type: 'server_up' }],
            conditions: [],
            steps: [
                {
                    type: 'action',
                    action: 'phone.notify',
                    params: { title: '{server} radi', text: 'Server se podigao u {vreme}.' },
                },
                {
                    type: 'action',
                    action: 'discord.send',
                    params: { text: '✅ {server} je ponovo online. Uđite!' },
                },
            ],
        },
    },
    {
        label: 'Prijatelj ušao',
        hint: 'Obaveštenje kad neko sa liste uđe',
        draft: {
            name: 'Prijatelj ušao',
            enabled: true,
            stopOnError: false,
            triggers: [{ type: 'player_join', names: [] }],
            conditions: [],
            steps: [
                { type: 'say', text: '{igrac} je ušao na server.' },
                {
                    type: 'action',
                    action: 'phone.notify',
                    params: { text: '{igrac} je ušao na {server}.' },
                },
            ],
        },
    },
    {
        label: 'Laku noć',
        hint: 'Ugasi muziku i zaključaj računar',
        draft: {
            name: 'Laku noć',
            enabled: true,
            stopOnError: false,
            triggers: [{ type: 'voice', phrase: 'idem da spavam' }],
            conditions: [],
            steps: [
                { type: 'action', action: 'media.control', params: { command: 'pause' } },
                { type: 'action', action: 'system.lock', params: {} },
                { type: 'say', text: 'Laku noć, šefe.' },
            ],
        },
    },
];
//# sourceMappingURL=templates.js.map